import networks from './networks'

export const getNetworkConfig = () => networks.mainnet
